import React from "react";
import Copy from "./Copy";

const CandidateAddress = (props: any) => {
	return (
		<>
			<Copy>{props.address.address}</Copy>
			<br />
			<br />
			<Copy>{props.address.addressLine1}</Copy>
			{props.address.addressLine2 &&
				props.address.addressLine2 !== props.address.addressLine1 && (
					<Copy>{props.address.addressLine2}</Copy>
				)}
			{props.address.addressLine3 &&
				props.address.addressLine3 !== props.address.addressLine2 && (
					<Copy>{props.address.addressLine3}</Copy>
				)}
			{props.address.city &&
				props.address.city !== props.address.addressLine3 && (
					<Copy>{props.address.city}</Copy>
				)}
			{props.address.region && props.address.region !== props.address.city && (
				<Copy>{props.address.region}</Copy>
			)}
			<Copy>{props.address.postcode}</Copy>
			<Copy>{props.address.country}</Copy>
		</>
	);
};
export default CandidateAddress;
